import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import homeSlice from "../home/homeSlice";

export const store = configureStore({
  reducer: {
    home: homeSlice,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
